<template><section><h1>Message 消息提示</h1>
<hr>
<ul>
<li>这次有些不一样，点开看看吧 (#^.^#)</li>
</ul>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<ul>
<li>UI 注册了一个<code v-pre>$message</code>方法用于调用。</li>
</ul>
<div class="demo-block">
  <h-button plain @click="open1">消息</h-button>
  <h-button plain @click="open2">成功</h-button>
  <h-button plain @click="open3">警告</h-button>
  <h-button plain @click="open4">错误</h-button>
</div>

<demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;html&gt;&lt;head&gt;&lt;template&gt;\n  &lt;h-button plain @click=\&quot;open1\&quot;&gt;消息&lt;/h-button&gt;\n  &lt;h-button plain @click=\&quot;open2\&quot;&gt;成功&lt;/h-button&gt;\n  &lt;h-button plain @click=\&quot;open3\&quot;&gt;警告&lt;/h-button&gt;\n  &lt;h-button plain @click=\&quot;open4\&quot;&gt;错误&lt;/h-button&gt;\n&lt;/template&gt;\n\n\n&lt;/head&gt;&lt;body&gt;&lt;/body&gt;&lt;/html&gt;&quot;,&quot;script&quot;:&quot;\n  export default {\n      methods: {\n        open1() {\n          this.$message('这是一条消息提示');\n        },\n        open2() {\n          this.$message({\n            message: '恭喜你，这是一条成功消息',\n            type: 'success'\n          });\n        },\n  \n        open3() {\n          this.$message({\n            message: '警告哦，这是一条警告消息',\n            type: 'warning'\n          });\n        },\n  \n        open4() {\n          this.$message.error('错了哦，这是一条错误消息');\n        }\n      }\n    }\n&quot;,&quot;style&quot;:null}">
                            <div class="source" slot="source"><html><head><template>
  <h-button plain @click="open1">消息</h-button>
  <h-button plain @click="open2">成功</h-button>
  <h-button plain @click="open3">警告</h-button>
  <h-button plain @click="open4">错误</h-button>
</template>


</head><body></body></html></div>
                            
                            <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open1"</span>&gt;</span>消息<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open2"</span>&gt;</span>成功<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open3"</span>&gt;</span>警告<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open4"</span>&gt;</span>错误<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
      <span class="hljs-attr">methods</span>: {
        open1() {
          <span class="hljs-keyword">this</span>.$message(<span class="hljs-string">'这是一条消息提示'</span>);
        },
        open2() {
          <span class="hljs-keyword">this</span>.$message({
            <span class="hljs-attr">message</span>: <span class="hljs-string">'恭喜你，这是一条成功消息'</span>,
            <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>
          });
        },
  
        open3() {
          <span class="hljs-keyword">this</span>.$message({
            <span class="hljs-attr">message</span>: <span class="hljs-string">'警告哦，这是一条警告消息'</span>,
            <span class="hljs-attr">type</span>: <span class="hljs-string">'warning'</span>
          });
        },
  
        open4() {
          <span class="hljs-keyword">this</span>.$message.error(<span class="hljs-string">'错了哦，这是一条错误消息'</span>);
        }
      }
    }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="an-niu-zhuang-tai"><a class="header-anchor" href="#an-niu-zhuang-tai" aria-hidden="true">¶</a> 按钮状态</h3>
<ul>
<li>可传入<code v-pre>isButton</code>参数及<code v-pre>buttonText</code>参数，该参数会覆盖<code v-pre>iconClass</code>，不显示图标，只显示传入文本或默认文本，并取消自动关闭。</li>
</ul>
<div class="demo-block">
  <h-button plain @click="open5">成功</h-button>
  <h-button plain @click="open6">警告</h-button>
  <h-button plain @click="open7">错误</h-button>
</div>
<demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;html&gt;&lt;head&gt;&lt;template&gt;\n  &lt;h-button plain @click=\&quot;open5\&quot;&gt;成功&lt;/h-button&gt;\n  &lt;h-button plain @click=\&quot;open6\&quot;&gt;警告&lt;/h-button&gt;\n  &lt;h-button plain @click=\&quot;open7\&quot;&gt;错误&lt;/h-button&gt;\n&lt;/template&gt;\n\n\n\n&lt;/head&gt;&lt;body&gt;&lt;/body&gt;&lt;/html&gt;&quot;,&quot;script&quot;:&quot;\n  &lt;script&gt;\n    export default {\n        methods: {\n          open5() {\n            this.$message({isButton:true,message:'这是一条消息提示'});\n          },\n          \n          open6() {\n            this.$message({\n              isButton:true,\n              message: '恭喜你，这是一条成功消息',\n              type: 'success',\n              buttonText:['喝香槟','去蹦迪'],\n              onClose:(data)=&gt;{\n                //会返回相应buttonText\n                console.log(data)\n              }\n            });\n          },\n    \n          open7() {\n            this.$message.error({\n              isButton:true,\n              message:'错了哦，这是一条错误消息',\n              buttonText:['重新来','出去玩'],\n              onClose:(data)=&gt;{\n                //会返回相应buttonText\n                console.log(data)\n              }\n            });\n          }\n      }\n  &quot;,&quot;style&quot;:null}">
                            <div class="source" slot="source"><html><head><template>
  <h-button plain @click="open5">成功</h-button>
  <h-button plain @click="open6">警告</h-button>
  <h-button plain @click="open7">错误</h-button>
</template>



</head><body></body></html></div>
                            
                            <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open5"</span>&gt;</span>成功<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open6"</span>&gt;</span>警告<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h-button</span> <span class="hljs-attr">plain</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open7"</span>&gt;</span>错误<span class="hljs-tag">&lt;/<span class="hljs-name">h-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="handlebars"><span class="xml">
  <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        <span class="hljs-attr">methods</span>: {
          open5() {
            <span class="hljs-keyword">this</span>.$message({<span class="hljs-attr">isButton</span>:<span class="hljs-literal">true</span>,<span class="hljs-attr">message</span>:<span class="hljs-string">'这是一条消息提示'</span>});
          },
          
          open6() {
            <span class="hljs-keyword">this</span>.$message({
              <span class="hljs-attr">isButton</span>:<span class="hljs-literal">true</span>,
              <span class="hljs-attr">message</span>: <span class="hljs-string">'恭喜你，这是一条成功消息'</span>,
              <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
              <span class="hljs-attr">buttonText</span>:[<span class="hljs-string">'喝香槟'</span>,<span class="hljs-string">'去蹦迪'</span>],
              <span class="hljs-attr">onClose</span>:<span class="hljs-function">(<span class="hljs-params">data</span>)=&gt;</span>{
                <span class="hljs-comment">//会返回相应buttonText</span>
                <span class="hljs-built_in">console</span>.log(data)
              }
            });
          },
    
          open7() {
            <span class="hljs-keyword">this</span>.$message.error({
              <span class="hljs-attr">isButton</span>:<span class="hljs-literal">true</span>,
              <span class="hljs-attr">message</span>:<span class="hljs-string">'错了哦，这是一条错误消息'</span>,
              <span class="hljs-attr">buttonText</span>:[<span class="hljs-string">'重新来'</span>,<span class="hljs-string">'出去玩'</span>],
              <span class="hljs-attr">onClose</span>:<span class="hljs-function">(<span class="hljs-params">data</span>)=&gt;</span>{
                <span class="hljs-comment">//会返回相应buttonText</span>
                <span class="hljs-built_in">console</span>.log(data)
              }
            });
          }
      }
  </span></span></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="quan-ju-fang-fa"><a class="header-anchor" href="#quan-ju-fang-fa" aria-hidden="true">¶</a> 全局方法</h3>
<p>Vue.prototype 添加了全局方法 $message。因此在 vue instance 中可以采用本页面中的方式调用。</p>
<h3 id="dan-du-yin-yong"><a class="header-anchor" href="#dan-du-yin-yong" aria-hidden="true">¶</a> 单独引用</h3>
<p>单独引入：</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">import</span> { Message } <span class="hljs-keyword">from</span> <span class="hljs-string">'hao-ui'</span>;
</code></pre>
<h3 id="options"><a class="header-anchor" href="#options" aria-hidden="true">¶</a> Options</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>message</td>
<td>消息文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>type</td>
<td>主题</td>
<td>string</td>
<td>success/warning/info/error</td>
<td>info</td>
</tr>
<tr>
<td>iconClass</td>
<td>自定义图标的类名，会覆盖 <code v-pre>type</code></td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>customClass</td>
<td>自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>duration</td>
<td>显示时间, 毫秒。设 0 或 isButton为true 则不自动关闭</td>
<td>number</td>
<td>—</td>
<td>3000</td>
</tr>
<tr>
<td>showClose</td>
<td>是否显示关闭按钮</td>
<td>boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>isButton</td>
<td>按钮状态，会覆盖iconClass及默认图标</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>buttonText</td>
<td>按钮文本，仅在isButton为true时有效</td>
<td>Array</td>
<td>—</td>
<td>['确定','取消']</td>
</tr>
<tr>
<td>onClose</td>
<td>关闭回调, 参数为当前message 实例或 对应buttonText</td>
<td>function</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3 id="fang-fa"><a class="header-anchor" href="#fang-fa" aria-hidden="true">¶</a> 方法</h3>
<p>调用 <code v-pre>Message</code> 或 <code v-pre>this.$message</code> 会返回当前 Message 的实例。如果需要手动关闭实例，可以调用它的 <code v-pre>close</code> 方法。</p>

</section></template>

<script>
  export default {
    methods: {
      open1() {
        this.$message('这是一条消息提示');
      },
      
      open2() {
        this.$message({
          message: '恭喜你，这是一条成功消息',
          type: 'success'
        });
      },

      open3() {
        this.$message({
          message: '警告哦，这是一条警告消息',
          type: 'warning'
        });
      },

      open4() {
        this.$message.error('错了哦，这是一条错误消息');
      },
      
      open5() {
        this.$message({isButton:true,message:'这是一条消息提示'});
      },
      
      open6() {
        this.$message({
          isButton:true,
          message: '恭喜你，这是一条成功消息',
          type: 'success',
          buttonText:['喝香槟','去蹦迪'],
          onClose:(data)=>{
            //会返回相应buttonText
            console.log(data)
          }
        });
      },

      open7() {
        this.$message.error({
          isButton:true,
          message:'错了哦，这是一条错误消息',
          buttonText:['重新来','出去玩'],
          onClose:(data)=>{
            //会返回相应buttonText
            console.log(data)
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/docs/message.vue